const translations = {
    justNow: 'just now',
    lastSynced: 'Last synced: {{date}}',
    relativeDays: '{{count}}d ago',
    relativeHours: '{{count}}h ago',
    relativeMinutes: '{{count}}m ago',
    synced: 'Synced'
};

export default translations;
